<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 9 13"><path d="M3.876 6.43l4.237 4.236c.2.2.2.519 0 .718L6.788 12.71c-.199.2-.519.2-.718 0L.15 6.789c-.2-.2-.2-.52 0-.719L6.07.15c.2-.2.519-.2.718 0l1.325 1.324c.2.2.2.519 0 .718L3.876 6.43z" /></svg>
</template>

<script>
export default {
  name: 'arrow',
};
</script>
